import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	isSorting: boolean;
	onChangeIsSorting: (isSorting: boolean) => void;

	onClickCancelSort: () => void;
	onClickSaveSort: () => void;
};

export const SortButton = ({ isSorting, onChangeIsSorting, onClickCancelSort, onClickSaveSort }: Props) => {
	const handleClickSaveOrStartSort = useCallback(() => {
		if (isSorting) {
			onClickSaveSort();
			onChangeIsSorting(false);
		} else {
			onChangeIsSorting(true);
		}
	}, [isSorting, onChangeIsSorting, onClickSaveSort]);

	const handleClickCancelSort = useCallback(() => {
		onClickCancelSort();
		onChangeIsSorting(false);
	}, [onClickCancelSort, onChangeIsSorting]);

	const sortingButtonText = isSorting ? "保存する" : "並び替え";

	return (
		<div className="flex gap-x-4">
			<Button variant={"outline"} type="button" size={"lg"} onClick={handleClickSaveOrStartSort}>
				{sortingButtonText}
			</Button>

			{isSorting && (
				<Button variant={"outline"} type="button" size={"lg"} onClick={handleClickCancelSort}>
					キャンセル
				</Button>
			)}
		</div>
	);
};

SortButton.displayName = "SortButton";
